import styled, { css } from 'styled-components/macro';
import { VStack } from '../stack';

export const StyledContainer = styled(VStack)`
  ${({ theme }) => css`
    position: relative;
    width: 100%;

    &::after {
      content: '';
      position: absolute;
      bottom: 0;
      left: 0;
      right: 0;
      height: 1px;
      background-color: ${theme.semantic.tab.borderTrack};
    }
  `}
`;

export const StyledSkeletonContainer = styled(StyledContainer)`
  &::after {
    background-color: transparent;
  }
`;

export const StyledTabsWrapper = styled.div<{
  $fadeLeft?: boolean;
  $fadeRight?: boolean;
}>`
  position: relative;
  z-index: 1;
  display: flex;
  overflow-x: auto;
  -ms-overflow-style: none;
  scrollbar-width: none;

  ${({ $fadeLeft, $fadeRight }) => css`
    mask-image: linear-gradient(
      to right,
      ${$fadeLeft ? 'transparent' : 'black'} 0,
      black 40px,
      black calc(100% - 40px),
      ${$fadeRight ? 'transparent' : 'black'} 100%
    );
  `}

  &::-webkit-scrollbar {
    display: none;
  }
`;

export const StyledTab = styled.div`
  ${({ theme }) => css`
    padding-inline: ${theme.spacings.base};
    display: flex;
    align-items: center;
    justify-content: center;
    width: fit-content;
    height: 40px;
    cursor: pointer;
    transition: color ${theme.tokens.animation.duration.base};

    @media (hover: hover) {
      &:hover {
        color: ${theme.semantic.tab.textHover};
      }
    }

    &[data-selected='true'] {
      color: ${theme.semantic.tab.textSelected};

      @media (hover: hover) {
        &:hover {
          color: ${theme.semantic.tab.textSelectedHover};
        }
      }
    }
  `}
`;

export const StyledIndicator = styled.div`
  ${({ theme }) => css`
    position: absolute;
    z-index: 1;
    bottom: 0;
    height: 1px;
    background-color: ${theme.semantic.tab.borderSelected};
    transition-property: width, transform;
    transition-duration: ${theme.tokens.animation.duration.base};
  `}
`;
